import qs from 'qs'

function resolve (src) {
  if (src.slice(0, 4) != 'http') {
    var a = document.createElement('a')
    a.href = src
    return a.href
  } else {
    return src
  }
}

function parse (src) {
  var a = document.createElement('a')
  a.href = src

  return {
    protocol: a.protocol,
    host: a.host,
    pathname: a.pathname,
    query: qs.parse(a.search)
  }
}

export default {
  resolve: resolve,
  parse: parse
}



// WEBPACK FOOTER //
// ./src/mods/pnurl.js